export const eventTypes = {
  SUPPORT_TICKET: '/api/contexts/SupportTicket',
  FILE_SERVICE: '/api/contexts/FileService',
  ORDER: '/api/contexts/Order',
  SUPPORT_MESSAGE: '/api/contexts/SupportTicketMessage',
  FILE_SERVICE_REMARKS: '/api/contexts/EngineerRemark',
};
